import Accordion from "@components/BasicComponents/Accordion/Accordion"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	FAQModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

type Props = {
	pageData: AdvancedSideAssetModuleType
	faq: FAQModuleType[]
}

const FAQSection = (props: Props) => {
	return (
		<section>
			<ContainerWrapper>
				<Typography
					content={props.pageData.sectionTitle}
					variant={Variant.SectionTitle}
				/>
				<Separator />
				<div itemType={"https://schema.org/FAQPage"} itemScope>
					<Accordion items={props.faq} />
				</div>
				<Separator />
				<Typography
					as={"h4"}
					content={props.pageData.sectionBottomTitle}
					size={Size.L}
					variant={Variant.Title}
				/>
				<Separator size={32} />
				<Separator withoutMeasure>
					<ButtonComponent
						buttonType={"secondary"}
						link={props.pageData.sectionBottomButtonLink}
						asLink
					>
						{props.pageData.sectionBottomButton}
					</ButtonComponent>
				</Separator>
				<Separator size={128} />
			</ContainerWrapper>
		</section>
	)
}

export default FAQSection
